export default __webpack_public_path__ + "static/media/History Dot, Red.a4de9454.png";